"use strict";

import angular from "angular";

import _ from "lodash";
import moment from "moment";

import { Company } from "../../../gateway/Company/Company";
import { Events } from "../../../presentation/services/Events/Events";
import { PointsAccountingAnalytics } from "../../../presentation/services/PointsAccountingAnalytics/PointsAccountingAnalytics";

class FeesCustomizationDialogCtrl {
    constructor($mdDialog, locals, DSNDialogService) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.DSNDialogService = DSNDialogService;

        this.Company = new Company();
        this.PointsAccountingAnalytics = new PointsAccountingAnalytics();

        this.newFee = 0;
        this.feesToRemove = [];
        this.editedFees = [];

        this.hasChanges = false;
        this.months = moment.months();
        this.month = false;
        this.year = moment().utcOffset(0).year();
        this.years = this._getYears(3);

        this._setFees();
        this.Events = new Events();
    }

    dateExists(month) {
        return this.viewFees.find((fee) => {
            return fee.dt === `${this.year}-${month + 1}`;
        });
    }

    _getYears(back) {
        const year = this.year;
        return Array.from({ length: back }, (v, i) => year - back + i + 1);
    }

    _setFees() {
        const fees = this.locals.fees.map((fee) => {
            return {
                dt: moment(fee.t).utcOffset(0).format("YYYY-MM"),
                t: moment(fee.t).utcOffset(0).format("MMMM/YYYY"),
                v: fee.v
            };
        });

        this.viewFees = _.sortBy(fees, "dt").reverse();
    }

    onChangeFee(fee) {
        fee.edited = true;
        this.hasChanges = true;
    }

    onRemoveFee($event, $index) {
        this.DSNDialogService.confirmation({
            targetEvent: $event,
            locals: {
                destructive: true,
                title: `Tem certeza que deseja remover o honorário de ${this.viewFees[$index].t}?`,
                actions: {
                    confirm: {
                        label: "Sim, remover!",
                        action: () => {
                            this.$mdDialog.hide(true);
                        }
                    },
                    cancel: {
                        label: "Cancelar",
                        action: () => {
                            this.$mdDialog.cancel();
                        }
                    }
                }
            },
            after: {
                hide: (response) => {
                    if (response) this.removeFee($index);
                },
                cancel: () => {}
            },
            multiple: true
        });
    }

    isDisabled() {
        if (this.loading) return true;
        if (this.hasChanges) return false;
        return this.month === false;
    }

    removeFee($index) {
        this.feesToRemove.push(this.viewFees[$index]);
        this.viewFees.splice($index, 1);

        this.hasChanges = true;
    }

    _formatToSave(date) {
        const month = this.month + 1;
        this.viewFees.push({
            dt: moment(date).utcOffset(0).format("YYYY-MM"),
            v: this.newFee,
            t: moment(`${this.year}-${month}`).utcOffset(0).format("MMMM/YYYY")
        });

        this.viewFees = _.sortBy(this.viewFees, "dt");

        const feesToSave = this.viewFees.map((fee) => {
            return {
                t: new Date(
                    moment(fee.dt).utcOffset(0).startOf("month").format()
                ),
                v: fee.v
            };
        });

        this.feesToSave = _.sortBy(feesToSave, "t");

        this.saveInDB();
    }

    onOpenDialogFeeBeeforeContract(date) {
        const time = new Date(
            moment(date).utcOffset(0).add(3, "hours").format()
        );

        if (+time < +this.locals.customerSince.date) {
            this.DSNDialogService.confirmation({
                locals: {
                    title: "",
                    description:
                        "A data do primeiro honorário está antes da data do início do contrato, deseja continuar?",
                    actions: {
                        confirm: {
                            label: "Continuar",
                            action: () => {
                                this.$mdDialog.hide();
                                this._formatToSave(date);
                            }
                        },
                        cancel: {
                            label: "Cancelar",
                            action: () => {
                                this.$mdDialog.cancel();
                            }
                        }
                    }
                },
                after: {
                    hide: () => {},
                    cancel: () => {}
                },
                multiple: true
            });
        } else this._formatToSave(date);
    }

    getFeesToSave() {
        if (this.month > -1) {
            const month = this.month + 1;
            const date = `${this.year}-${month}`;
            this.onOpenDialogFeeBeeforeContract(date);
        }

        const feesToSave = this.viewFees.map((fee) => {
            return {
                t: new Date(
                    moment(fee.dt).utcOffset(0).startOf("month").format()
                ),
                v: fee.v
            };
        });

        return _.sortBy(feesToSave, "t");
    }

    onSave() {
        this.Events.send(
            "contabilidade.carteira.empresas.performance.tabela.honorarios.alterar"
        );
        this.viewFees.forEach((fee) => {
            if (fee.edited) {
                this.editedFees.push({
                    t: new Date(`${fee.dt}-01`),
                    v: fee.v
                });
            }
        });

        if (this.month !== false && this.month > -1) {
            const month = this.month + 1;
            const date = `${this.year}-${month}`;
            this.onOpenDialogFeeBeeforeContract(date);
        } else {
            const feesToSave = this.viewFees.map((fee) => {
                return {
                    t: new Date(
                        moment(fee.dt).utcOffset(0).startOf("month").format()
                    ),
                    v: fee.v
                };
            });

            this.feesToSave = _.sortBy(feesToSave, "t");

            this.saveInDB();
        }
    }

    async saveInDB() {
        this.loading = true;
        const fees = this.feesToSave.map((f) => {
            return {
                ...f,
                t: f.t.toISOString()
            };
        });
        try {
            await this.Company.updateFields(
                this.locals.accountingId,
                this.locals.companyId,
                { fees }
            );
            this.$mdDialog.hide(fees);
        } catch (error) {
            this.$mdDialog.cancel();
        }
        this.loading = false;
    }
}
angular
    .module("nucont.shared")
    .controller("FeesCustomizationDialogCtrl", [
        "$mdDialog",
        "locals",
        "DSNDialogService",
        FeesCustomizationDialogCtrl
    ]);
